// API 주소 자동 설정
// 우선순위:
//   1. REACT_APP_API_BASE (Phase 2.3 도메인 분리 후 https://api.autodex.kr)
//   2. production: window.location.origin (Phase 2.3 이전 단일 도메인 운영 — 폴백)
//   3. development: http://localhost:4000
var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
var _runtimeBase = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:4000';
var API_ORIGIN = _envBase || _runtimeBase;
var API = API_ORIGIN + '/api';

// 업체 계정이면 companyId 쿼리 파라미터 추가하는 헬퍼
var carsUrl = function(user) {
  if (user && user.role === '업체' && user.companyId > 0) {
    return API + '/cars?companyId=' + user.companyId;
  }
  return API + '/cars';
};

// JWT 토큰 관리
var getToken = function() {
  return localStorage.getItem('autodoc_token') || '';
};

// 세션 만료(401) 중앙 처리 — 한 번만 안내+로그아웃 (동시 다발 401 중복 alert 방지)
var _authExpiredHandled = false;
var handleAuthExpired = function(code) {
  if (_authExpiredHandled) return;
  _authExpiredHandled = true;
  var msg = code === 'SESSION_SUPERSEDED'
    ? '다른 기기/창에서 로그인되어 로그아웃되었습니다. 다시 로그인해주세요.'
    : '세션이 만료되었습니다. 다시 로그인해주세요.';
  try { window.alert(msg); } catch (_e) {}
  try { localStorage.removeItem('autodoc_token'); sessionStorage.removeItem('autodoc_user'); } catch (_e) {}
  var rt = (window.location.pathname && window.location.pathname.charAt(0) === '/') ? window.location.pathname : '/main';
  window.location.href = '/login?returnUrl=' + encodeURIComponent(rt);
};

// 인증 헤더 포함 fetch (점진적 적용용)
var authFetch = function(url, options) {
  options = options || {};
  options.headers = options.headers || {};
  var token = getToken();
  if (token) {
    options.headers['Authorization'] = 'Bearer ' + token;
  }
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json';
  }
  return fetch(url, options).then(function(res) {
    // 토큰이 있는데 401 → 세션 무효(다른 기기 로그인/만료/로그아웃 블랙리스트).
    // SESSION_SUPERSEDED 등 백엔드 신호를 잡아 안내 후 로그인 유도 (이전엔 무시 → CarList 등 빈 화면/크래시).
    if (res.status === 401 && getToken()) {
      res.clone().json().then(function(body) {
        handleAuthExpired(body && body.code);
      }).catch(function() { handleAuthExpired(null); });
    }
    return res;
  });
};

export { API, API_ORIGIN, carsUrl, getToken, authFetch };
export default API;
